module.exports = __webpack_public_path__ + "images/category_lp/brand/new/assessment_achievements/5@2x_b27d9e0d7e607e98c5ebc3124cbb424d.png";